import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Nav({ setMobileToggle }) {
  return (
    <ul className="cs_nav_list fw-medium text-uppercase">
      <li>
        <NavLink
          to="/"
          end
          className={({ isActive }) => (isActive ? 'active' : undefined)}
          onClick={() => setMobileToggle && setMobileToggle(false)}
        >
          Home
        </NavLink>
        {/* <DropDown>
          <ul>
            <li>
              <NavLink to="/" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Business
              </NavLink>
            </li>
            <li>
              <NavLink to="/corporate" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Corporate
              </NavLink>
            </li>
            <li>
              <NavLink to="/finance" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Financial institute
              </NavLink>
            </li>
            <li>
              <NavLink to="/insurance" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Insurance Company
              </NavLink>
            </li>
            <li>
              <NavLink to="/consulting" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Consulting Agency
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/business-with-ecommerce"
                onClick={() => setMobileToggle && setMobileToggle(false)}
              >
                Business With E-Commerce
              </NavLink>
            </li>
          </ul>
        </DropDown> */}
      </li>
      <li>
        <NavLink
          to="/about"
          className={({ isActive }) => (isActive ? 'active' : undefined)}
          onClick={() => setMobileToggle && setMobileToggle(false)}
        >
          About
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/projects"
          className={({ isActive }) => (isActive ? 'active' : undefined)}
          onClick={() => setMobileToggle && setMobileToggle(false)}
        >
          Projects
        </NavLink>
      </li>
      {/* <li className="menu-item-has-children">
        <NavLink to="#">Pages</NavLink>
        <DropDown>
          <ul>
            <li>
              <NavLink
                to="/portfolio/portfolio-details"
                onClick={() => setMobileToggle && setMobileToggle(false)}
              >
                Project Details
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/service/services-details"
                onClick={() => setMobileToggle && setMobileToggle(false)}
              >
                Service Details
              </NavLink>
            </li>
            <li>
              <NavLink to="/team" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Team{' '}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/team/team-details"
                onClick={() => setMobileToggle && setMobileToggle(false)}
              >
                Team Member
              </NavLink>
            </li>
            <li>
              <NavLink to="/pricing" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Pricing List
              </NavLink>
            </li>
            <li>
              <NavLink to="/shop" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Our Store
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/shop/product-details"
                onClick={() => setMobileToggle && setMobileToggle(false)}
              >
                Product Details
              </NavLink>
            </li>
            <li>
              <NavLink to="/shop-cart" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Shop Cart
              </NavLink>
            </li>
            <li>
              <NavLink to="/shop-checkout" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Shop Checkout
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/shop-order-recived"
                onClick={() => setMobileToggle && setMobileToggle(false)}
              >
                Success Order
              </NavLink>
            </li>
          </ul>
        </DropDown>
      </li> */}
      <li>
        <NavLink
          to="/service"
          className={({ isActive }) => (isActive ? 'active' : undefined)}
          onClick={() => setMobileToggle && setMobileToggle(false)}
        >
          Services
        </NavLink>
      </li>
      {/* <li>
        <NavLink to="/portfolio" onClick={() => setMobileToggle && setMobileToggle(false)}>
          Portfolio
        </NavLink>
      </li>
      <li className="menu-item-has-children">
        <NavLink to="/blog" onClick={() => setMobileToggle && setMobileToggle(false)}>
          Blog
        </NavLink>
        <DropDown>
          <ul>
            <li>
              <NavLink to="/blog-grid" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Blog Grid
              </NavLink>
            </li>
            <li>
              <NavLink to="/blog" onClick={() => setMobileToggle && setMobileToggle(false)}>
                Blog List With Sidebar
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/blog/blog-details"
                onClick={() => setMobileToggle && setMobileToggle(false)}
              >
                Blog Details
              </NavLink>
            </li>
          </ul>
        </DropDown>
      </li> */}
      <li>
        <NavLink
          to="/contact"
          className={({ isActive }) => (isActive ? 'active' : undefined)}
          onClick={() => setMobileToggle && setMobileToggle(false)}
        >
          Contact
        </NavLink>
      </li>
    </ul>
  );
}
